document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collection-slider').forEach(section => {
    const swiperEl = section.querySelector('.collection-slider__swiper');
    const prevBtn = section.querySelector('.collection-slider__arrow--prev');
    const nextBtn = section.querySelector('.collection-slider__arrow--next');

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 2.25,
      spaceBetween: 16,
      watchOverflow: true,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn
      },
      breakpoints: {
        750: {
          slidesPerView: 4,
          spaceBetween: 24
        }
      },
      on: {
        init(swiper) {
          section.classList.add('is-initialized');
          toggleScrollable(swiper);
        },
        resize(swiper) {
          toggleScrollable(swiper);
        }
      }
    });

    function toggleScrollable(swiper) {
      if (swiper.isLocked) {
        section.classList.remove('is-scrollable');
      } else {
        section.classList.add('is-scrollable');
      }
    }
  });
});
